import { ChangeDetectionStrategy, Component, ElementRef, HostListener, inject, input, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NavigationMenuPanelComponent } from '@layout/navigation/components/navigation-menu-panel/navigation-menu-panel.component';

@Component({
  selector: 'itc-navigation-menu',
  templateUrl: 'navigation-menu.component.html',
  styleUrl: 'navigation-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NavigationMenuPanelComponent, TranslatePipe],
})
export class NavigationMenuComponent {
  private readonly elementRef = inject(ElementRef);

  readonly headerElement = input.required<HTMLElement>();
  readonly isNavigationMenuOpen = signal(false);

  @HostListener('document:click', ['$event'])
  onHeaderClick(event: MouseEvent): void {
    const targetComposedPath = event.composedPath();

    if (targetComposedPath.includes(this.headerElement()) && !targetComposedPath.includes(this.elementRef.nativeElement)) {
      this.isNavigationMenuOpen.set(false);
    }
  }

  @HostListener('window:popstate')
  onWindowNavigation(): void {
    this.isNavigationMenuOpen.set(false);
  }

  toggleNavigationMenu(): void {
    this.isNavigationMenuOpen.update(isOpen => !isOpen);
  }
}
